module.exports = __webpack_public_path__ + "img/img7.59ade59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img7.png
// module id = 216
// module chunks = 0